var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"myTree",attrs:{"data":_vm.treeData,"default-expand-all":false,"props":_vm.defaultProps,"render-content":_vm.renderContent,"accordion":"","expand-on-click-node":false},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }